import { Directive, Host, OnInit, Self } from '@angular/core';
import { Icd10SearchBody } from '@arcadia/workflow-shared-risk';

import { Icd10CodeSearchService } from '@assess/browser/icd10-code-search';
import { trackByFunctions } from '@assess/browser/track-by-functions';
import { IIcd10SearchRecord } from '@assess/shared/data-mart';
import { SearchBody } from '@assess/shared/data-mart-search';

import { displayWithFn, LookupSearchComponent } from '../../components/lookup-search/lookup-search.component';
import { trySetProp } from '../try-set-prop';

@Directive({
  selector: 'assess-lookup-search[assessIcd10Search]',
})
export class Icd10SearchDirective implements OnInit {
  readonly searchInputEmptyMessage = 'No matching codes found';
  readonly searchInputLabel = 'ICD-10';
  readonly searchInputPlaceholder = 'Search by ICD-10 Code or Dx Description...';
  readonly searchResultTrackBy = trackByFunctions.by('Code');

  constructor(
    private readonly icd10CodeSearchService: Icd10CodeSearchService,
    @Host() @Self() private searchComponent: LookupSearchComponent
  ) {}

  readonly commonDisplayWith: displayWithFn = (value: IIcd10SearchRecord) => {
    if (!value) {
      return '';
    }

    return `(${value?.Code}) ${value?.Description}`;
  };

  readonly searchWith: LookupSearchComponent['searchWith'] = (
    body: SearchBody<Icd10SearchBody['searchParameters']>
  ) => {
    return this.icd10CodeSearchService.search(body);
  };

  ngOnInit() {
    trySetProp(this.searchComponent, 'selectionDisplayWith', this.commonDisplayWith);

    trySetProp(this.searchComponent, 'searchInputEmptyMessage', this.searchInputEmptyMessage);
    trySetProp(this.searchComponent, 'searchInputLabel', this.searchInputLabel);
    trySetProp(this.searchComponent, 'searchInputPlaceholder', this.searchInputPlaceholder);
    trySetProp(this.searchComponent, 'searchResultDisplayWith', this.commonDisplayWith);
    trySetProp(this.searchComponent, 'searchResultTrackBy', this.searchResultTrackBy);
    trySetProp(this.searchComponent, 'searchWith', this.searchWith);
  }
}
